<template>
  <div id="demo-basic-card">
    <div id="dashboard-analytics" style="margin-left: -15px;" >
      <div class="vx-col w-full mb-2" :class="{'detail-compare-branding' : screen == false, 'full-views' : screen == true}" style="margin-top:-24px" >
        <div class="vx-row full-size" style="padding:0px 0px 0px 15px">
          <vx-card :headerPadding="true" slot="no-body" class="p-1" style="box-shadow: none !important;">
            <div class="vx-row">
              <div class="vx-col w-full scroll-header ml-4" style="display: flex">
                <div class="md:w-5/6" style="">
                  <span style="font-size: 16px;font-weight: bold">{{$t('realtimeChart.boxTime')}}: </span>
                  <date-range-picker
                    ref="picker"
                    :locale-data="{ format: 'dd/mm/yyyy' }"
                    :opens="'right'"
                    @update="reloadData"
                    v-model="dateRange">
                  </date-range-picker>
                </div>
                <div class="md:w-1/6 pr-4" style="display: flex;justify-content: flex-end;border-left: 1px solid rgba(71, 78, 93,0.3)">
                  <vs-button
                    class="text-size"
                    icon-pack="feather"
                    icon="icon-download"
                    @click="exportBrandData"
                    style="border-radius:20px;">{{$t('compareBranding.save')}}</vs-button>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-row p-0 pl-4 mt-2 full-size" >
          <div class="w-full" style="background-color: #F8F8F8 !important;padding: 0.5rem 1.5rem 1.5rem 1.5rem">
            <div class="vx-row pb-2">
              <div class="mt-2  title-t1" style="float:left;width: 114.39px;overflow: inherit;white-space: nowrap;">
                <span class="title-menu ">{{$t('compareBranding.numberOfMentions')}}</span>
              </div>
              <div class="vx-row title-t2" style="margin-left: 80px;">
                <div class="vx-col w-full mt-2 width-col  buttonSelect" v-for="(itemSelected,indexOptional) in optionalSelectedTopic"
                     style="padding: 0 1.15rem !important;">
                  <div class="btnSelected w-full cursor-pointer" :title="itemSelected.label" :style="{background:itemSelected.color}">
                    <div class="button-topic w-full" @click="activeSidebar(itemSelected,indexOptional)">
                      <span class="cursor-pointer"  style="color: white;">{{itemSelected.label}}</span>
                    </div>
                    <div v-if="itemSelected.index > 4"  class="md:w-1/6" style="display: flex;align-items: center">
                      <feather-icon  icon="XIcon" class="iconX cursor-pointer"  @click="deleteColumn(indexOptional,itemSelected)"></feather-icon>
                    </div>
                  </div>
                </div>
                <div class="ml-6 mt-3 cursor-pointer addBtn" @click="addCompareBranding">
                  <span class="font-semibold text-primary" style="font-size: 14px;" >+ {{$t('compareBranding.addCompare')}}</span>
                </div>
              </div>
            </div>
            <!-- số lần nhắc tới -->
            <div class="vx-row style-text-row" v-for="(item, index) in optionalArticle" :key="index " style="margin-bottom: 5px;background-color: white;border-radius: 10px!important;">
              <div class="vx-col w-full scroll-topic" style="width:14rem !important;border-radius: 10px 0px 0px 10px;">
                <div>
                  <span class="text-label">{{ item.label }}</span>
                </div>
              </div>
              <div class="vx-col w-full pl-6 width-col " v-for="(data, index1) in item.value" :key="index1"  >
                <div>
                  <div class="vx-row" style="justify-content: center;" v-if="data > 0 && data == item.maxValue">
                    <span class="text-value ml-4">{{eArabic(data)}}</span>
                    <img src="@/assets/images/icon-facebook/king-crown.png" alt="" class="mt-1" style="height:1rem;width:1rem;margin-left:2px"/>
                  </div>
                  <div class="vx-row" style="justify-content: center;" v-else>
                    <span class="text-value" v-if="data != null ">{{ eArabic(data) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- sắc thái -->
            <div class="vx-row pb-2">
              <div class="mt-4 " style="float:left;">
                <span class="title-menu">{{$t('title.shades')}}</span>
              </div>
            </div>
            <div class="vx-row style-text-row" v-for="(item) in optionalClassification" style="margin-bottom: 5px;background-color: white;border-radius: 10px!important;">
              <div class="vx-col w-full scroll-topic" style="width:14rem !important;border-radius: 10px 0px 0px 10px;">
                <div >
                  <span class="text-label">{{ item.label }}</span>
                </div>
              </div>

              <div class="vx-col w-full pl-6 width-col" v-for="(dataClass,indexClassifi) in item.value" :key="indexClassifi" style="">
                <div>
                  <div class="vx-row" style="justify-content: center;" v-if="dataClass > 0 && item.maxValue == dataClass">
                    <span class="text-value ml-4 ">{{eArabic(dataClass)}}<span v-if="dataClass != null">%</span></span>
                    <img src="@/assets/images/icon-facebook/king-crown.png" alt="" class="mt-1" style="height:1rem;width:1rem;margin-left:2px" />
                  </div>
                  <div class="vx-row" style="justify-content: center;" v-else>
                    <span class="text-value" v-if="dataClass != null">{{ eArabic(dataClass) }}%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row" style="display:none;">
              <div class="" style="float:left">
                <span class="title-menu">&nbsp;</span>
              </div>
            </div>
            <!-- Top 5 -->
            <div class="vx-row  pb-2">
              <div class="mt-4" style="float:left">
                <span class="title-menu">{{$t('compareBranding.textTop5')}}</span>
              </div>
            </div>
            <div class="vx-row style-text-row" style ="border-radius: 10px;background: white;margin-bottom: 5px;" v-for="(index,indexNumber) in initMainKeywordData" >
              <div class="vx-col w-full scroll-topic" style="width:14rem !important;">
                <div >
                  <span class="text-label">Top {{indexNumber+1}}</span>
                </div>
              </div>
              <div class="vx-col w-full pl-6 width-col" v-for="(item, index1) in optionalArticle "  style="display: flex;justify-content: center;">
                <div v-if="index == 0 && optionalArticle[index1].mainKeywordLoading" class="lds-facebook"><div></div><div></div><div></div></div>
                <span class="text-top5" >{{item.mainKeyword[index]}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-sidebar :open.sync="isActiveSideBar" click-not-close hidden-background position-right parent="body"  color="primary" class="sidebarx sidebarpage sidebar-custom" spacer v-model="active">
        <div class="header-sidebar w-full" slot="header" style="display: flex;justify-content: space-between;">
          <h4 class="mt-2 ml-2">
            {{$t('compareBranding.selectCompare')}}
          </h4>
          <feather-icon icon="XIcon" @click="active= false"></feather-icon>
        </div>
        <div class="vx-col w-full ml-4">
          <div class="vx-col mr-2"  >
            <VuePerfectScrollbar
              style="max-height: 635px;"
              class="scroll-area--nofications-dropdown p-0"
              :settings="settings"
            >
              <vs-collapse accordion>
                <vs-collapse-item v-for="(group, index) in optionGroupTopics" v-bind:key="index">
                  <div slot="header">
                    <div class="vx-row">
                      <div v-if="group.color" class="color-group mt-0 p-0 text-center text-white mt-1"
                           :style="{background:group.color}">
                      </div>
                      <div v-else class="color-group mt-0 p-0 text-center text-white mt-1"
                           style="background-color:rgba(var(--vs-primary), 1)">
                      </div>
                      <span class="ml-2 mt-1 font-bold" style="font-size: 16px;color:  rgb(94 88 115)">{{ group.label }}</span>
                    </div>
                  </div>
                  <div class="topic cursor-auto">
                    <div class="vx-row div-topic text-warp-topic w-full p-3 style-align cursor-pointer" style="font-size: 16px"
                         v-for="(item, index) in topics.filter(el => el.topicGroupId == group.value)"
                         :key="index"
                         @click="dropdownBranding(item,null,group.color)">
                      <div class="md:w-5/6 pr-6 style-align">
                        <feather-icon
                          icon="ListIcon"
                          class="ml-2"
                          style="width: 1rem;height: 1rem"
                        >
                        </feather-icon>
                        <span class="ml-2 text-warp-topic" style="font-size: 14px">{{ item.topicName }}</span>
                      </div>
                      <div class="md:w-1/6 style-align">
                        <img v-if="item.pinTopic == true" class=" mr-3" src="@/assets/images/icon-facebook/pin-topic.png" style="height: 12px;width: 12px;" @click="pinTopic(item,null)">
                        <img v-else class=" mr-3" src="@/assets/images/icon-facebook/pin.png" style="height: 12px;width: 12px" @click="pinTopic(item,null)">
                      </div>
                    </div>
                  </div>
                </vs-collapse-item>
                <vs-collapse-item>
                  <div slot="header">
                    <div class="vx-row">
                      <div class="count-other text-white text-center"></div>
                      <span class="ml-1 mt-1 ml-2 font-bold"
                            style="font-size: 15px;color:  rgb(94 88 115)">{{
                          $t('projectAndTopic.otherTopics')
                        }}</span>
                    </div>
                  </div>
                  <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0"
                                       :settings="settings" style="max-height: 18rem">
                    <div class="topic cursor-auto text-overflow">
                      <div class="vx-row div-topic text-warp-topic w-full p-3 style-align cursor-pointer" style="font-size: 16px"
                           v-for="(item, index) in topics.filter(el => el.isOther)"
                           :key="index"
                           @click="dropdownBranding(item,null,null)">
                        <div class="md:w-5/6 pr-6 style-align">
                          <feather-icon
                            icon="ListIcon"
                            class="ml-2"
                            style="width: 1rem;height: 1rem"
                          >
                          </feather-icon>
                          <span class="ml-2 text-warp-topic" style="font-size: 12pt">{{ item.topicName }}</span>
                        </div>
                        <div class="md:w-1/6 style-align">
                          <img v-if="item.pinTopic == true" class=" mr-3" src="@/assets/images/icon-facebook/pin-topic.png" style="height: 12px;width: 12px;" @click="pinTopic(item,null)">
                          <img v-else class=" mr-3" src="@/assets/images/icon-facebook/pin.png" style="height: 12px;width: 12px" @click="pinTopic(item,null)">
                        </div>
                      </div>
                    </div>
                  </VuePerfectScrollbar>
                </vs-collapse-item>
              </vs-collapse>
            </VuePerfectScrollbar>
          </div>
        </div>
        <div class="w-full button-footer mb-8" >
          <vs-button class="ml-6 " type="border" @click="active = false"> {{$t('button.closed')}}</vs-button>
        </div>
      </vs-sidebar>
    </div>
  </div>
</template>
<script>
import DateRangePicker from "@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import vSelect from "vue-select";
import authConfig from '@/../auth_config.json';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    DateRangePicker,
    vSelect,VuePerfectScrollbar,
  },
  data() {
    return {
      isActiveSideBar: false,
      indexBtn:{},
      active: false,
      lengthSelected : null,
      checkFavorite: false,
      checkPin:false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .30,
        suppressScrollX: true,
      },
      screen:false,
      dataBinding:[],
      topic: [],
      typeBranding:null,
      topics:[],
      optionalBranding:[
        {label:'Thương hiệu cá nhân', value:0},
        {label:'Thương hiệu tổ chức', value:1},
        {label:'Thương hiệu sản phẩm', value:2},
        {label:'Thương hiệu khác', value:-1}
      ],
      initArrayData:[],
      initMainKeywordData: [0, 1, 2, 3, 4],
      optionalArticle: (()=>{
        let initArrayData = [null, null, null, null, null]
        let initMainKeywordData = [null, null, null, null, null];
        let obj = [{ label: this.$t('compareBranding.allOfChannel'), value: initArrayData, maxValue:null, mainKeyword: initMainKeywordData, mainKeywordLoading: false},
          { label: "Kênh tin tức", value: initArrayData, maxValue:null, mainKeyword: initMainKeywordData,  mainKeywordLoading: false},
          { label: "Facebook (bài viết)", value: initArrayData, maxValue:null, mainKeyword: initMainKeywordData,  mainKeywordLoading: false},
          { label: "Facebook (bình luận)", value: initArrayData, maxValue:null, mainKeyword: initMainKeywordData,  mainKeywordLoading: false},
          { label: "Youtube", value:initArrayData, maxValue:null, mainKeyword: initMainKeywordData,  mainKeywordLoading: false},
          { label: "Forum", value: initArrayData  , maxValue:null, mainKeyword: initMainKeywordData,  mainKeywordLoading: false}]
        return obj;
      })(),
      optionalClassification: (() =>{
        let initArrayData = [null,null,null,null,null]
        let object =[
          { label: "Tích cực", value: initArrayData, maxValue:null},
          { label: "Trung lập", value: initArrayData, maxValue:null},
          { label: "Tiêu cực", value: initArrayData, maxValue:null}
        ]
        return object;
      })(),
      optionalSelectedTopic:[
        {label:'Chọn', index:0, id: null, color:'#419bf9'},
        {label:'Chọn', index:1, id: null, color:'#419bf9'},
        {label:'Chọn', index:2, id: null, color:'#419bf9'},
        {label:'Chọn', index:3, id: null, color:'#419bf9'},
        {label:'Chọn', index:4, id: null, color:'#419bf9'},
      ],
      optionGroupTopics:[],
      optionalCountBrandingByTopic:[],
      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date();
          date.setDate(date.getDate() - 6);
          date.setHours(0, 0, 0);
          return date;
        })()
      },
      topicIdBranding:null,
      topicIdBrandingProduct:null,
      topicIdBrandingPersonal:null,
      topicIdBrandingOther: null,
      topicIdBrandingOther2:null,
      brandingName:'Chọn',
      brandingNameOther2:'Chọn',
      brandingNameProduct:'Chọn',
      brandingNamePersonal:'Chọn',
      brandingNameOther:'Chọn',
      countBranding:{},
      pinType:null,
      indexSelectedCol:null,
      arrTopicId:new Array(10),
      checkDuplicateTopic:false,
      selectedDropdowns:[],
      topicIdbrandings:[],
      activeBorder:false
    };
  },
  computed: {
    compareBrandingSelected: {
      get() {
        let object = this.optionalBranding.find((el) => el.value === this.typeBranding);
        if(!object) return null;
        return {
          label:object.label,
          value:object.value
        }
      },
      set(object) {
        this.typeBranding = object.value
      }
    }
  },
  methods: {
    eArabic: function(x) {
      return x.toLocaleString("de-DE");
    },
    activeSidebar(item){
      // document.getElementsByClassName('vs-sidebar')[0].style.setProperty('z-index','1000000','important');
      // document.getElementsByClassName('vs-sidebar')[0].style.minWidth='350px';

      this.isActiveSideBar = true;
      this.$vs.loading();
      this.indexBtn = item;
      setTimeout(()=>{
        this.active = !this.active
        this.$vs.loading.close();}, 500);
    },
    deleteColumn:function (item) {
      if(item > 0){
        const result = this.optionalSelectedTopic.slice(0, item)
        const resultToIndex = this.optionalSelectedTopic.slice(item);
        resultToIndex.forEach(el => el.index = el.index -1);
        this.optionalSelectedTopic = [...result, ...resultToIndex];
        this.minusWidth();
      }
      else{
        this.optionalSelectedTopic = this.optionalSelectedTopic.slice(item);
        this.optionalSelectedTopic.forEach(el => el.index = el.index -1);
      }
      this.optionalSelectedTopic.splice(item,1);
      this.arrTopicId.splice(item,1);
      for(let i=0;i<6;i++){
        this.optionalArticle[i].value.splice(item,1);
      }
      for(let j=0;j<4;j++){
        if (this.optionalClassification[j]){
          this.optionalClassification[j].value.splice(item,1);
        }
      }
      this.optionalArticle[item].mainKeyword.splice(0,5);
      this.active = false;
    },
    addCompareBranding: function(){
      const index = this.optionalSelectedTopic.length;
      if(index > 18){
        return this.$vs.notify({
          text:this.$t('compareBranding.textAmount'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'danger'
        })
      }
      if (!this.activeBorder) {
        this.optionalArticle[0].value.push(null);
        this.optionalClassification[0].value.push(null);
      }
      else{
        this.optionalArticle.forEach(el => {
          el.value.push(null);
        })
        this.optionalClassification.forEach(el => {
          el.value.push(null);
        })
      }
      this.addWidth();
      const object ={
        label: this.$t('compareBranding.selection'),
        index: index,
        id: null,
        color:'#419bf9'
      }
      this.optionalSelectedTopic.push(object);
    },
    pinTopic: function(event,indexSelected){
      if(indexSelected == null) {
        indexSelected = this.indexBtn;
      }
      const index = indexSelected.index;
      if(index > 9){
        return this.$vs.notify({
          text: this.$t('compareBranding.position'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'danger'
        })
      }
      this.arrTopicId.splice(indexSelected.index,1);
      this.pin(event,indexSelected);
      // this.dropdownBranding(event,indexSelected);
    },
    pin: function(event,index){
      this.lengthSelected = index.index;
      const payload ={
        id:event.id,
        pinType: index.index
      }
      const data = this.topics.filter(topic => topic.id == event.id && topic.topicGroupId == event.topicGroupId);
      if(data[0].pinTopic == true && data[0].pinType != index.index){
        return this.$vs.notify({
          text: this.$t('compareBranding.textTheme') + `${event.topicName}`,
          icon:'icon-alert',
          iconPack:'feather',
          color:'danger'
        })
      }

      this.$business.post(`topic/pin-topic`,payload).then(() =>{
        if(event.topicName.length > 20){
          event.topicName = event.topicName.slice(0,20) + '...';
        }
        index.label = event.topicName;
        this.topicIdBranding = event.id;
        this.arrTopicId[index.index] = event.id;
        this.brandingName = event.topicName
        this.refreshData(index)
        setTimeout(() => {
          location.reload();
        }, 1000);
        this.$vs.notify({
          text: `${event.pinTopic ? this.$t('compareBranding.unpin') : this.$t('compareBranding.pin')}` +' '+ this.$t('compareBranding.textTheme')+' '+`${event.topicName}`,
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }).catch((err) =>{
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
    },
    reloadData () {
      for (let i = 0 ; i < this.optionalSelectedTopic.length ; i ++) {
        let column = this.optionalSelectedTopic[i];
        if (!column.id) continue;
        let topic = JSON.parse(JSON.stringify(this.topics.find(topic => topic.id = column.id)))
        topic.topicName = column.label;
        this.loadTopicData(topic, column, i * 1000)
      }
    },
    loadTopicData(payload, indexSelected, timeout) {
      setTimeout(() => {
        this.lengthSelected = indexSelected.index;
        this.dropdownBranding(payload,indexSelected,null);
      }, timeout)
    },
    initScreen() {
      this.getTopicGroups().then(() =>{
        this.getTopic();
      });
      this.dateRange.startDate = new Date(
        this.dateRange.startDate.setHours(0, 0, 0)
      );
      this.dateRange.endDate = new Date(
        this.dateRange.endDate.setHours(23, 59, 59)
      );
      this.from = this.dateRange.startDate;
      this.to = this.dateRange.endDate;
      const selected = this.optionalSelectedTopic.filter(el => el.label != 'Chọn');
      selected.forEach(item => {
        this.topicIdBranding = item.id;
        this.refreshData(item);
      })
      this.updateI18n();
    },
    getTopic: function(){
      this.$business.post(`topic/find-by-conditions`,{}).then((res) =>{
        this.$business.post(`share-topic/get-all-share`, {}).then((topicShareRes) =>{
          let data = this.topics = [...res.data,...topicShareRes.data.filter(item => item.status === 1)];
          data = data.map(item => {
            item.isOther = true;
            if (this.optionGroupTopics.find(group => {
              return group.value == item.topicGroupId
            })) {
              item.isOther = false;
            }
            return item;
          });
          this.topics = data;
          if(this.topics.length > 0){
            let favouriteTopic = this.topics.find(item => item.favourite);
            let hasFouvarite = 0
            if (favouriteTopic) {
              this.checkFavorite = true;
              let selected = {
                label:favouriteTopic.topicName,
                index:0,
                id: favouriteTopic.id
              }
              this.dropdownBranding(favouriteTopic, selected,null);
              hasFouvarite = 1;
            }
            let pinTopic = this.topics.filter(item => item.pinTopic);
            let hasPinTopic = 0;
            if(pinTopic.length > 0){
              this.checkPin = true;
              pinTopic.forEach(pin =>{
                const selected = {
                  label: pin.topicName,
                  index: favouriteTopic ? pin.pinType : pin.pinType,
                  id: pinTopic.id
                }
                this.dropdownBranding(pin,selected,null)
                hasPinTopic += 1;
              })
            }
            if (this.$route.query.data) {
              let arrId = [];
              arrId = this.$route.query.data.split(",");
              let total = arrId.length + hasFouvarite + hasPinTopic;
              // if(total > 10){
              //   return this.$vs.notify({
              //     text:`Vượt quá số lượng từ khóa so sánh`,
              //     icon:'icon-alert',
              //     iconPack:'feather',
              //     color:'danger'
              //   })
              // }
              if(total > 10){
                const slice = 10 - (hasFouvarite + hasPinTopic);
                arrId = arrId.slice(0,slice)
              }
              const result = [];
              arrId.forEach(filter =>{
                const a = this.topics.find(el => el.id == filter);
                result.push(a)
              })
              const dataResult = [];
              this.optionalSelectedTopic.filter(el => el.id)
                .forEach(el => dataResult.push(el.index));
              for(let i=0;i<dataResult.length;i++){
                this.lengthSelected = i;
                const selectedDirection = {
                  label:result[i].topicName,
                  index: dataResult[i]
                }
                this.dropdownBranding(result[i],selectedDirection,null);
              }
            }
          }
          data.forEach(el =>{
            el.keyword = el.keywords.map(k => k.keyword).join(", ");
          })
        })
      })
    },
    getTopicGroups: function(){
      return new Promise((resolve,reject) =>{
        this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
          this.optionGroupTopics = res.data;
          if(this.optionGroupTopics.length > 0){
            this.optionGroupTopics = this.optionGroupTopics.map(el =>{
              return {
                label:el.groupName,
                value:el.id,
                color:el.color
              }
            })
          }
          resolve();
        }).catch(() => reject())
      })
    },
    countArticleByTopicId: function(payload,indexSelectedOrigin){
      let indexSelected = JSON.parse(JSON.stringify(indexSelectedOrigin))
      const id = this.topicIdBranding;
      let selectedFilter = this.optionalSelectedTopic.filter(el => el.id).length;
      let lengthSelected = this.lengthSelected;
      if (lengthSelected == selectedFilter - 1){
        this.$vs.loading();
      }
      this.$processor.post('/user-data/count-article',payload).then((res) =>{
        const total = [];
        const dataCompare = [];
        const dataCompareProduct = [];
        const dataComparePersonal = [];
        const dataCompareOther = [];
        const dataCompareOther2 = [];
        const dataComparepositive= [];
        const dataComapareNegative = [];
        const dataCompareNeutral = [];
        this.optionalCountBrandingByTopic = res.data;
        if(id){
          const countData = res.data.filter(el => el.topicId ==  id);
          let optionalArticle = JSON.parse(JSON.stringify(this.optionalArticle))
          optionalArticle[0].value[indexSelected.index || 0] = countData.map(value => value.news)[0] + countData.map(value => value.facebookPost)[0]
            + countData.map(value => value.facebookComment)[0]
            + countData.map(value => value.youtube)[0]
            + countData.map(value => value.forum)[0];
          optionalArticle[1].value[indexSelected.index || 0] = countData.map(value => value.news)[0];
          optionalArticle[2].value[indexSelected.index || 0] = countData.map(value => value.facebookPost)[0];
          optionalArticle[3].value[indexSelected.index || 0] = countData.map(value => value.facebookComment)[0];
          optionalArticle[4].value[indexSelected.index || 0] = countData.map(value => value.youtube)[0];
          optionalArticle[5].value[indexSelected.index || 0] = countData.map(value => value.forum)[0];
          this.optionalArticle = optionalArticle
          total.push(this.optionalArticle[0].value);
          dataCompare.push(this.optionalArticle[1].value);
          dataCompareProduct.push(this.optionalArticle[2].value);
          dataComparePersonal.push(this.optionalArticle[3].value);
          dataCompareOther.push(this.optionalArticle[4].value);
          dataCompareOther2.push(this.optionalArticle[5].value);
          let optionalClassification = JSON.parse(JSON.stringify(this.optionalClassification));
          optionalClassification[0].value[indexSelected.index || 0] = countData.map(value => value.positive)[0];
          optionalClassification[1].value[indexSelected.index || 0] = countData.map(value => value.neutral)[0];
          optionalClassification[2].value[indexSelected.index || 0] = countData.map(value => value.negative)[0];
          let positivePercent = optionalClassification[0].value[indexSelected.index || 0],
            neutralPercent = optionalClassification[1].value[indexSelected.index || 0],
            negativePercent = optionalClassification[2].value[indexSelected.index || 0];
          let totalShade = positivePercent + neutralPercent + negativePercent;
          if (totalShade != 0){
            optionalClassification[0].value[indexSelected.index || 0] = parseInt((positivePercent/totalShade)*100) ;
            optionalClassification[1].value[indexSelected.index || 0] = parseInt((neutralPercent/totalShade)*100);
            optionalClassification[2].value[indexSelected.index || 0] = 100 - (parseInt((positivePercent/totalShade)*100)+parseInt((neutralPercent/totalShade)*100));
          }
          this.optionalClassification = optionalClassification;
          dataComparepositive.push(this.optionalClassification[0].value);
          dataCompareNeutral.push(this.optionalClassification[1].value);
          dataComapareNegative.push(this.optionalClassification[2].value);
          this.optionalArticle[0].maxValue = Math.max(...total[0].filter(el => el));
          this.optionalArticle[1].maxValue = Math.max(...dataCompare[0].filter(el => el));
          this.optionalArticle[2].maxValue = Math.max(...dataCompareProduct[0].filter(el => el));
          this.optionalArticle[3].maxValue = Math.max(...dataComparePersonal[0].filter(el => el));
          this.optionalArticle[4].maxValue = Math.max(...dataCompareOther[0].filter(el => el));
          this.optionalArticle[5].maxValue = Math.max(...dataCompareOther2[0].filter(el => el));
          this.optionalClassification[0].maxValue = Math.max(...dataComparepositive[0].filter(el => el));
          this.optionalClassification[1].maxValue = Math.max(...dataCompareNeutral[0].filter(el => el));
          this.optionalClassification[2].maxValue = Math.max(...dataComapareNegative[0].filter(el => el));

          if (lengthSelected == selectedFilter - 1){
            this.$vs.loading.close();
          }
        }
      }).catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
      this.optionalArticle[indexSelectedOrigin.index].mainKeywordLoading = true;
      this.optionalArticle[indexSelectedOrigin.index].mainKeyword = [];
      this.$processor.post('/user-data/count-topic-main-keyword',payload).then((res) =>{
        let mainKeywords = Object.keys(res.data).filter(item => item.includes("_")).sort((keyword1, keyword2) => {
          return res.data[keyword2] - res.data[keyword1];
        }).map(item => item.replaceAll("_", " ")).slice(0, 5);
        this.optionalArticle[indexSelectedOrigin.index].mainKeyword = mainKeywords;
        this.optionalArticle[indexSelectedOrigin.index].mainKeywordLoading = false;
      }).catch((err) =>{
        this.optionalArticle[indexSelectedOrigin.index].mainKeywordLoading = false;
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
    },
    dropdownBranding: function(event,indexSelected,color){
      if(indexSelected == null) {
        indexSelected = this.indexBtn;
      }
      this.active = false;
      if(event.id){
        this.activeBorder = true;
        if(this.arrTopicId.includes(event.id) && indexSelected.id != event.id){
          this.checkDuplicateTopic = true;
          return this.$vs.notify({
            text:this.$t('compareBranding.textChoose'),
            icon:'icon-alert',
            iconPack:'feather',
            color:'danger'
          });
        }
        indexSelected.label = event.topicName;
        if(color) {
          indexSelected.color = color;
        }
        indexSelected.id = event.id;
        this.topicIdBranding = event.id;
        this.indexSelectedCol = indexSelected.index;
        this.refreshData(indexSelected);
        this.arrTopicId[indexSelected.index] = event.id;
      }
    },
    refreshData: function(indexSelected) {
      this.lengthSelected = indexSelected.index;
      if(indexSelected){
        this.optionalSelectedTopic.forEach(el => {
          if(el.index == indexSelected.index){
            el.label = indexSelected.label;
            el.id = indexSelected.id
          }
        });
      }
      if(this.topicIdBranding){
        const payload = {
          from:this.dateRange.startDate,
          to: this.dateRange.endDate,
          topicIdBranding: this.topicIdBranding,
          topicId: this.topicIdBranding
        }
        if(indexSelected || indexSelected.index === 0) {
          this.countArticleByTopicId(payload,indexSelected);
        }
      }
    },
    exportBrandData: function () {
      const payload = {
        from:this.dateRange.startDate,
        to: this.dateRange.endDate,
        topics: this.arrTopicId.filter( item => item)
      }
      let url = "user-data/export-excel-brand";
      let packageApiPermission = this.$root.businessPackage.permissions.reduce((arr,item) => {
        arr.push(...item.functionApiPrefix.split(";"))
        return arr;
      }, []);
      let apiPermission = this.$root.permissionList.reduce((arr,item) => {
        arr.push(...item.functionApiPrefix.split(";"))
        return arr;
      }, []);
      if (apiPermission.includes(url) && !packageApiPermission.includes(url)) {
        return this.$vs.notify({
          text: this.$t('noPermission'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.$report.post('user-data/export-excel-brand', payload).then((response) => {
        this.$vs.loading.close();
        if (!response || !response.data) return this.$vs.notify({
          text: this.$t('createReportError'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
        window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
        return this.$vs.notify({
          text:this.$t('compareBranding.textReport'),
          icon:'icon-alert',
          iconPack:'feahter',
          color:'color'
        })

      })

    },
    addWidth:function () {
      let totalWidth=null
      let widthTitle=null
      let widthTitle2=null
      let widthBtn=null;
      let widthBtnAdd=null;
      if(document.getElementsByClassName('full-size')[0]){
        totalWidth=parseInt(document.getElementsByClassName('full-size')[0].clientWidth);
        widthTitle=parseInt(document.getElementsByClassName('title-t1')[0].clientWidth);
        widthTitle2=parseInt(document.getElementsByClassName('title-t2')[0].clientWidth);
        for (let i = 0; i < document.getElementsByClassName('buttonSelect').length; i++) {
          widthBtn += parseInt(document.getElementsByClassName('buttonSelect')[i].clientWidth);
        }
        widthBtnAdd=parseInt(document.getElementsByClassName('addBtn')[0].clientWidth);
      }
      let widthRest = null;
      widthRest=totalWidth- (widthTitle + widthTitle2);
      if(widthRest< 250){
        this.screen=true;
        let addFullScreen = totalWidth + 133;
        if(addFullScreen > totalWidth){
          if(document.getElementsByClassName('full-size')[0]){
            return document.getElementsByClassName('full-size')[0].style.width=`${addFullScreen}px`,
              document.getElementsByClassName('full-size')[1].style.width=`${addFullScreen}px`
          }
        }
      }
    },
    minusWidth:function () {
      let totalWidth=null
      if(document.getElementsByClassName('full-size')[0]){
        totalWidth=parseInt(document.getElementsByClassName('full-size')[0].clientWidth);
        let addFullScreen = totalWidth - 133;
        if(addFullScreen <  window.screen.width-260){
          addFullScreen = window.screen.width - 62 - 260;
          this.screen=false;
        }
        return document.getElementsByClassName('full-size')[0].style.width=`${addFullScreen}px`,
          document.getElementsByClassName('full-size')[1].style.width=`${addFullScreen}px`;
      }
    },
    updateI18n: function(){
      this.optionalArticle[0].label = this.$t('compareBranding.allOfChannel');
      this.optionalArticle[1].label =  this.$t('compareBranding.newsChannel');
      this.optionalClassification[0].label = this.$t('title.positive');
      this.optionalClassification[1].label =  this.$t('title.neutral');
      this.optionalClassification[2].label = this.$t('title.negative')
      this.optionalSelectedTopic.map(el => {
        el.label = this.$t('compareBranding.selection')
      })
    }
  },
  beforeDestroy: function () {
    this.$eventBus.$off('dataSelected');
    this.active = false;
  },
  async created() {
    this.$eventBus.$on('i18n', () =>{
      this.updateI18n();
    })
    this.initScreen();
    let that = this;
    document.getElementsByTagName('body')[0].addEventListener('click', () => {
      document.getElementsByClassName('vs-sidebar')[1].addEventListener('click',()=>{
        that.active = false;
      });
      document.getElementsByClassName('v-nav-menu')[0].addEventListener('click',()=>{
        that.active = false;
      });
    })
  },
}
</script>
<style lang="scss">

@import "@/assets/scss/vuexy/components/vxCard.scss";
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
.branding {
  text-align: left;
  justify-content: center;
  font-size: 2.2rem;
  font-weight: bold;
}
.title-menu {
  font-size: 16px;
  font-weight: bold;
  margin-left: 1rem;
}
.border-bottom-title{
  border-bottom: 1px solid #c2c6dc;
}
.dropdown-scroll{
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  max-height: 10rem;
}
.dropdown-scroll::-webkit-scrollbar-track
{
  background-color: #F5F5F5;
  border-radius: 5px;
}
.dropdown-scroll::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

.dropdown-scroll::-webkit-scrollbar-thumb
{
  background-color: #cccccc;
  border: 1px solid #cccccc;
}
.color-text{
  color:black !important;
  background-color: white;
}
.reportrange-text{
  border-radius: 10px !important;
}
.topic-name{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large).vs-button-border {
  padding: .679rem 2rem;
}
.button-topic{
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media(max-width:3840px) {
  .width-col{
    width:9.5rem !important;
  }
}
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.full-views{
  overflow-y: hidden !important;
  overflow-x: scroll !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  height: auto;
}
.full-views::-webkit-scrollbar-track
{
  background-color: #F5F5F5;
  border-radius: 5px;
}
@media screen and (max-width:1360px) {
  .detail-compare-branding {
    overflow-y: hidden !important;
    overflow-x: hidden !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: auto;
    height: auto;
  }

  .detail-compare-branding::-webkit-scrollbar-track
  {
    background-color: #F5F5F5;
    border-radius: 5px;
  }
  .detail-compare-branding::-webkit-scrollbar
  {
    width: 10px;
    background-color: #F5F5F5;
  }

  .detail-compare-branding::-webkit-scrollbar-thumb
  {
    background-color: #cccccc;
    border: 1px solid #cccccc;
  }
}
.iconX{
  bottom: 30px;
  top: 0px;
  left: -4px;
  color: white;
  transform: scale(0.5);
}
.full-views::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

.full-views::-webkit-scrollbar-thumb
{
  background-color: #cccccc;
  border: 1px solid #cccccc;
  width: -moz-max-content;
}
.border-right{
  border-right:1px solid #ccc
}
.scroll-topic{
  position:sticky;
  left: 10px;
  background-color: white;
  border-radius: 5px;
}
.scroll-header{
  position:sticky;
  left: 0px;
  // background-color: white;
  z-index: 1;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, .5, .5, 1) infinite
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -.24s
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -.12s
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}

@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px
  }

  50%, 100% {
    top: 16px;
    height: 4px
  }
}
</style>
<style scoped>
.text-warp-topic{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btnSelected{
  height: 28px;
  border-radius: 5px;
  padding: 0px;
  width: 122px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-label{
  font-size: 16px;
  color: #B9B9C3;
  line-height: 21px;
}
.text-top5{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-value{
  font-size: 14px;
  font-family: Roboto, Helvetica, sans-serif;
}
.style-text-row{
  display: flex;
  align-items: center;
  height: 36px;
}
.button-footer{
  position: fixed;
  bottom: 0px;
  background-color: white;
  height: 40px;
}
.style-align{
  display: flex;
  align-items: center;
}
.color-group {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  font-size: 12px;
}
.count-other {
  margin-top: 2px;
  width: 20px;
  height: 20px;
  background-color: #0A7FFD;
  border-radius: 5px;
  font-size: 12px;
}
.div-topic:hover{
  background-color: rgb(0,123,255) !important;
  color: white;
  border-radius: 5px;
}
</style>

<style lang="css">
.sidebar-custom .vs-sidebar {
  min-width: 324px;
  z-index: 999999 !important;
}
</style>
